import Header from "@components/Header.jsx";
import {useEffect, useState} from "react";
import fetchContent from "@/utils/fetchContent.jsx";

const ContactsPage = () => {
    const [content, setContent] = useState("");

    useEffect(() => {
        const loadContent = async () => {
            const data = await fetchContent("contact", "doc1");
            setContent(data);
        };

        loadContent();
    }, []);

    return (
        <div className={`contacts-page`}>

            <div className={`wrapper`}>
                <div className={`page page-app`}>
                    <Header title='Contacts' />
                    <div
                        className="page-content"
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                </div>
            </div>
        </div>

    )
}

export default ContactsPage;